import apiClient from './apiClient'

export interface WhatsAppConnection {
  id: number
  session_name: string
  status: 'disconnected' | 'authenticating' | 'connected' | 'failed'
  qr_code?: string
  created_at: string
  updated_at: string
}

export interface WhatsAppContact {
  id: string
  name?: string
  number: string
  isGroup: boolean
  isUser: boolean
  isWAContact: boolean
}

export interface WhatsAppChat {
  id: string
  name: string
  isGroup: boolean
  unreadCount: number
  lastMessage?: {
    body: string
    timestamp: number
    type: string
  }
}

export interface SendMessageData {
  to: string
  message: string
  media?: string
}

export const whatsappService = {
  // Conectar bot
  async connect(sessionId: number): Promise<{ success: boolean; message?: string }> {
    try {
      const response = await apiClient.post(`/whatsapp/${sessionId}/connect`)
      return response.data
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao conectar'
      }
    }
  },

  // Desconectar bot
  async disconnect(sessionId: number): Promise<{ success: boolean; message?: string }> {
    try {
      const response = await apiClient.post(`/whatsapp/${sessionId}/disconnect`)
      return response.data
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao desconectar'
      }
    }
  },

  // Obter QR Code
  async getQRCode(sessionId: number): Promise<{ success: boolean; qrCode?: string; message?: string }> {
    try {
      const response = await apiClient.get(`/whatsapp/${sessionId}/qr`)
      return response.data
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'QR Code não disponível'
      }
    }
  },

  // Obter status da conexão
  async getStatus(sessionId: number): Promise<{ 
    success: boolean; 
    status?: string; 
    isConnected?: boolean; 
    qrCode?: string; 
    message?: string 
  }> {
    try {
      const response = await apiClient.get(`/whatsapp/${sessionId}/status`)
      return response.data
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao obter status'
      }
    }
  },

  // Enviar mensagem
  async sendMessage(sessionId: number, data: SendMessageData): Promise<{ 
    success: boolean; 
    messageId?: string; 
    message?: string 
  }> {
    try {
      const response = await apiClient.post(`/whatsapp/${sessionId}/send`, data)
      return response.data
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao enviar mensagem'
      }
    }
  },

  // Obter contatos
  async getContacts(sessionId: number): Promise<{ 
    success: boolean; 
    contacts?: WhatsAppContact[]; 
    message?: string 
  }> {
    try {
      const response = await apiClient.get(`/whatsapp/${sessionId}/contacts`)
      return response.data
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao obter contatos'
      }
    }
  },

  // Obter chats
  async getChats(sessionId: number): Promise<{ 
    success: boolean; 
    chats?: WhatsAppChat[]; 
    message?: string 
  }> {
    try {
      const response = await apiClient.get(`/whatsapp/${sessionId}/chats`)
      return response.data
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao obter chats'
      }
    }
  },

  // Obter conversas
  async getConversations(sessionId: number, page = 1, limit = 20): Promise<{ 
    success: boolean; 
    conversations?: WhatsAppChat[]; 
    pagination?: {
      page: number
      limit: number
      total: number
      totalPages: number
    };
    message?: string 
  }> {
    try {
      const response = await apiClient.get(`/whatsapp/${sessionId}/conversations`, {
        params: { page, limit }
      })
      return response.data
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao obter conversas'
      }
    }
  }
}





